<template>
  <div class="lib__form__announcement lib__form__announcement--sent">
    <h2 class="lib__text-success">
      <i class="far fa-check-circle"></i>
      {{ $t('confirmation.title', [title.toLowerCase()]) }}
    </h2>
    <p data-cy="send-confirmation-message" v-html="$t('confirmation.send', [email])"></p>
    <p v-if="!noNextContact">{{ $t('confirmation.nextContact') }}</p>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ContactInfo } from '@/models'
import { contactService } from '@/services'

@Component({ name: 'send-confirmation' })
export default class SendConfirmation extends Vue {
  //#region [Property]
  @Prop({ type: String, required: true }) public readonly title!: string
  @Prop({ type: Object, required: true }) public readonly contactInfo!: ContactInfo
  @Prop({ type: Boolean, default: false }) public readonly noNextContact!: boolean
  //#endregion

  //#region [Data]
  public email: string = ''
  //#endregion

  //#region [Watch]
  public onContactInfoChanged(value: ContactInfo) {
    this.email = contactService.getContactEmail(value)
  }
  //#endregion

  //#region [Method]
  public mounted() {
    this.onContactInfoChanged(this.contactInfo)
  }
  //#endregion
}
</script>